// MuseIQ Client Application - State Management

import type { AppState, PracticeScope } from './types.js';

const PRACTICE_SCOPE_KEY = 'conductorPracticeScope';

function loadPracticeScope(): PracticeScope {
    try {
        const raw = localStorage.getItem(PRACTICE_SCOPE_KEY);
        if (raw === 'lh' || raw === 'rh' || raw === 'both') return raw;
    } catch {
        // localStorage unavailable — fall through
    }
    return 'both';
}

// State management
export const state: AppState = {
    role: null,
    userRole: null, // Admin or conductor role
    username: null, // Logged-in username
    sessionId: null,
    joinCode: null, // 3-character join code for multi-session support
    sliceId: null,
    playerId: null, // Player ID (e.g., "Player 1", "Player 2")
    alphaTabApi: null, // alphaTab API instance
    playerReady: false, // alphaTab player ready state
    currentTime: 0,
    playbackState: 'stopped',
    playbackSpeed: 1.0,
    lastSyncTime: 0,
    syncIntervalId: null,
    heartbeatIntervalId: null,
    slices: [],
    players: [], // List of connected players
    latency: 0, // Latency offset in milliseconds (-1000 to 1000, adjustable by player)
    rtt: 0, // Round-trip time in milliseconds
    rttSamples: [], // Last 5 RTT samples for averaging
    pingIntervalId: null, // Interval ID for ping measurements
    authToken: null, // Authentication token for conductor
    authExpires: null, // Token expiration timestamp
    conductorToken: null, // Conductor session token for reconnection
    trackVisibility: null, // Track visibility state
    volume: 1.0, // Audio volume (0 = muted, 1 = full volume)
    metronomeVolume: 0, // Metronome volume (0 = off, 1 = full)
    countInEnabled: false, // Count-in enabled state
    testModeEnabled: false, // Test mode state from server (for reconnection)
    practiceModeEnabled: false, // Practice mode state from server (for reconnection)
    practiceScope: loadPracticeScope() // LH/RH/Both (persisted to localStorage)
};

// Cleanup function
export function cleanup(): void {
    if (state.syncIntervalId) {
        clearInterval(state.syncIntervalId);
        state.syncIntervalId = null;
    }

    if (state.heartbeatIntervalId) {
        clearInterval(state.heartbeatIntervalId);
        state.heartbeatIntervalId = null;
    }

    if (state.pingIntervalId) {
        clearInterval(state.pingIntervalId);
        state.pingIntervalId = null;
    }
}
